module.exports = __webpack_public_path__ + "hotel-restaurant.23a94e135199f4c7c549.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/hotel-restaurant/webfont/hotel-restaurant.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/hotel-restaurant/webfont/hotel-restaurant.svg
// module chunks = styles